import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

@Injectable({
    providedIn: 'root',
})
export class NavigationService {
    constructor(
        private _router: Router,
        private _keycloakService: KeycloakService
    ) {}

    isKioskModeEnabled() {
        return localStorage.getItem('kioskMode') === 'true';
    }

    navigateToUsersList() {
        const keycloak = this._keycloakService.getKeycloakInstance();
        const url = `${keycloak.authServerUrl}admin/master/console/#/${keycloak.realm}/users`;
        window.open(url, '_blank');
    }

    navigateToApplicationsDashboard() {
        this._router.navigate(['/home/dashboard']);
    }

    navigateToAnagraficheDashboard() {
        this._router.navigate(['/anagrafiche/dashboard']);
    }

    navigateToCreateAnagrafica() {
        this._router.navigate(['/anagrafiche/create']);
    }

    navigateToSearchAnagrafica() {
        this._router.navigate(['/anagrafiche/cerca']);
    }

    navigateToCommercialSubjects() {
        this._router.navigate(['/anagrafiche/commercial-subjects']);
    }

    navigateToMap() {
        this._router.navigate(['/anagrafiche/map']);
    }
}
